import React from 'react';
import PropTypes from 'prop-types';

const LoadingSpinner = ({ text, size }) => {
  return (
    <div className='loading-spinner-container' style={{textAlign : 'center'}}>
      <i className={`fa fa-spinner fa-spin fa-${size || '5'}x fa-align-center`} />
      <br/>
      {text ?
        <span className='loading-text'>
          {text}
        </span> :
      null}
    </div>
  );
}

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./src/browser/components/ui/loading-spinner.js